import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import { isProduction } from './auth';

const root = ReactDOM.createRoot(document.getElementById('root'));
const disableConsole = () => {
  if (isProduction() ){
    console.log = function () {};
    console.info = function () {};
  }
  // console.warn = function () {};
  // console.error = function () {};
};

disableConsole();

root.render(
  <React.StrictMode>
     <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
